import React, { forwardRef } from 'react';
import Select from 'react-select';
import { useCurrentViewPropertySession } from 'src/hooks/use-current-view-property-session';
import { useViewer } from 'src/hooks/use-viewer';
import { BasicGlobal } from '~static/svg-components';
import {
  contentHeaderSelectComponents,
  useContentHeaderSelectStyles,
} from './content-header-select-props';
import ContentHeaderSelectReadOnly from './content-header-select-read-only';

const getOptionLabel = (option) => option?.name;
const getOptionValue = (option) => option?.id;

const Control = forwardRef((props, ref) => (
  <contentHeaderSelectComponents.Control ref={ref} Icon={BasicGlobal} {...props} />
));

function LandlordSelect(props) {
  const { readOnly, ...otherProps } = props;
  const {
    currentRole: {
      accessScope: { landlords },
    },
  } = useViewer();
  const [{ currentViewLandLord }] = useCurrentViewPropertySession();

  const styles = useContentHeaderSelectStyles();

  return readOnly ? (
    <ContentHeaderSelectReadOnly Icon={BasicGlobal} title={currentViewLandLord.name} />
  ) : (
    <Select
      value={currentViewLandLord}
      components={{ ...contentHeaderSelectComponents, Control }}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      options={landlords}
      styles={styles}
      {...otherProps}
    />
  );
}

export default LandlordSelect;
